
import {defineComponent, PropType} from 'vue'
import {MenuScheduleNormalized} from "../defs";

export default defineComponent({
  name: "ScheduleDisplay",
  props: {
    normalizedSchedule: {
      type: Object as PropType<MenuScheduleNormalized>,
      required: true,
    },
  },
  computed: {
    scheduleAppliesToMenuTypes(): string {
      const output = [];
      if (this.normalizedSchedule.schedule_is_textual) {
        output.push('Textual (Outlet Page)');
      }
      if (this.normalizedSchedule.schedule_is_visual) {
        output.push('Visual (iPad)');
      }

      if (output.length) {
        return output.join(', ');
      }

      return 'None';
    },

    scheduleStartDateTime(): string {
      if (this.normalizedSchedule.schedule_start_datetime) {
        return window.pepDateFunctions.formatDateTimeReadable(new Date(this.normalizedSchedule.schedule_start_datetime));//.replace(' at ', '<br>@ ');
      }

      return 'No Limitation';
    },
    scheduleEndDateTime(): string {
      if (this.normalizedSchedule.schedule_end_datetime) {
        return window.pepDateFunctions.formatDateTimeReadable(new Date(this.normalizedSchedule.schedule_end_datetime));//.replace(' at ', '<br>@ ');
      }

      return 'No Limitation';
    },
  },
})
